import download from "./download.svg";
import copyToClipboard from "./copy-to-clipboard.svg";
import facebook from "./facebook.svg";
import messenger from "./messenger.svg";
import whatsapp from "./whatsapp.svg";
import twitter from "./twitter.svg";

const shareIcons = {
  download,
  copyToClipboard,
  facebook,
  messenger,
  whatsapp,
  twitter,
};

export default shareIcons;
